function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun_Download_322224",
  transform: "translate(-5.097 -7.825)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6140",
  "data-name": "Group 6140",
  transform: "translate(5.097 7.825)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3516",
  "data-name": "Path 3516",
  d: "M34.283,26.008c.188.188.4.376.59.563a.624.624,0,0,0,.858,0c1.4-1.288,2.763-2.575,4.158-3.836.188-.188.4-.376.59-.563.563-.537-.3-1.368-.858-.858-1.234,1.154-2.5,2.307-3.729,3.461V8.409a.6.6,0,0,0-1.207,0V24.774l-3.139-2.9c-.188-.188-.4-.376-.59-.563-.563-.537-1.422.322-.858.858C31.52,23.459,32.888,24.72,34.283,26.008Z",
  transform: "translate(-23.256 -7.825)",
  fill: "#f37b2d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3517",
  "data-name": "Path 3517",
  d: "M28.009,66.035v3.971a1.134,1.134,0,0,1-.08.537A.847.847,0,0,1,27.07,71H7.137a.818.818,0,0,1-.778-.51,1.332,1.332,0,0,1-.054-.483v-4a.6.6,0,0,0-1.207,0v3.407a3.657,3.657,0,0,0,.241,1.69,2.155,2.155,0,0,0,1.851,1.1H26.936a2.562,2.562,0,0,0,.778-.08,2.1,2.1,0,0,0,1.529-2.066V66.035A.618.618,0,0,0,28.009,66.035Z",
  transform: "translate(-5.097 -49.972)",
  fill: "#f37b2d"
})));

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.146,
    height: 22.234,
    viewBox: "0 0 24.146 22.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d7ef5fed2a6f19be0c48aaad71f5bb50.svg";
export { ForwardRef as ReactComponent };